"use client";

import ChatGptPixel from "./chatgpt-pixel";
import Gtag from "./gtag";
import MetaPixel from "./meta-pixel";
import TikTokPixel from "./tiktok-pixel";

// Pixels mounted on every (marketing) and (app) route. Each pixel
// initialises in its own `useEffect` (deferred to browser idle time when
// available) — see the per-pixel files for details. The previous
// interaction-gated lazy loader was removed: it left `window.gtag` /
// `fbq` / `ttq` undefined on `/success`, which is reached via a server
// redirect from Stripe Checkout with no user interaction, silently
// dropping every conversion call there.
//
// Note: Intercom is NOT in this aggregator — it's mounted as a facade
// (react-live-chat-loader) inside `app/(marketing)/_lib/intercom-facade.tsx`
// scoped to the marketing route group, so it doesn't double-up with the
// secure-mode Intercom boot inside `<Main>` on `(app)/` routes. Churnkey
// is also NOT here — it's mounted directly inside the only page that
// needs it (`app/(app)/(dashboard)/billing/page.tsx`).
export default function AnalyticsScripts() {
  return (
    <>
      <TikTokPixel />
      <MetaPixel />
      <Gtag />
      <ChatGptPixel />
    </>
  );
}
